import React, { useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/button";
import { Card } from "../../../components/card";
import { RecentActivityListView } from "../components/RecentActivityListView";
import { useGetRecentActivityList } from "../hooks/useGetRecentActivityList";

const PAGE_SIZE = 10;

const RecentActivityPage: React.FC = () => {
  const { t } = useTranslation();
  const { activities, loading, error, page, setPage, totalCount, refetch } =
    useGetRecentActivityList();
  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  const handlePageChange = useCallback(
    (nextPage: number) => {
      setPage(nextPage);
    },
    [setPage],
  );

  return (
    <Card className="p-6 border-none rounded-none flex flex-col bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700">
      <div className="flex justify-between items-center mb-6">
        <h1
          className="text-2xl font-bold text-[#020817] dark:text-white"
          style={{ fontFamily: "Nunito" }}
        >
          {t("recent_activity.notifications_title")}
        </h1>
        <Button
          variant="outline"
          size="sm"
          onClick={() => void refetch()}
          disabled={loading}
          className="flex items-center gap-2 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
          {t("ui.refresh")}
        </Button>
      </div>
      <RecentActivityListView
        activities={activities}
        loading={loading}
        error={error}
        page={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        labels={{
          all: t("recent_activity.all_badge"),
          loading: t("recent_activity.loading_activities"),
          empty: t("recent_activity.no_activities_available"),
        }}
      />
    </Card>
  );
};

export default RecentActivityPage;
